import MainContainer from "../ui/main";

const Routes = (): JSX.Element => {
  return <MainContainer />;
};

export default Routes;
